import { useCallback } from 'react';

import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../../../../../categories/categoriesTypes';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';
import { PureButtonHelper } from '../../../../../../../../../helpers/buttons/PureButtonHelper';

interface ThreeDStockMaterialsFiltersCategoriesFilterItemCategory {
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

interface ThreeDStockMaterialsFiltersCategoriesFilterItemProps {
  category: ThreeDStockMaterialsFiltersCategoriesFilterItemCategory;
  onCheckedCategory: (categoryId: CategoryID) => void;
  onChangeCategory: (categoryId: CategoryID) => void;
  checked: boolean;
}

function ThreeDStockMaterialsFiltersCategoriesFilterItem({
  onCheckedCategory,
  onChangeCategory,
  category,
  checked
}: ThreeDStockMaterialsFiltersCategoriesFilterItemProps) {
  const handleCheck = useCallback(() => {
    onCheckedCategory(category.id);
  }, [onCheckedCategory, category]);

  const handleChange = useCallback(() => {
    onChangeCategory(category.id);
  }, [onChangeCategory, category]);

  return (
    <li>
      <div className="py-1 flex items-center">
        <Checkbox
          dataGa={`category-${category.localizedName}`}
          checked={checked}
          onChange={handleCheck}
        />

        <PureButtonHelper
          className="grow text-left ml-2 block text-sm text-gray-900 dark:text-gray-100 hover:underline hover:font-medium"
          i18nText={category.localizedName}
          onClick={handleChange}
        />
      </div>
    </li>
  );
}

export default ThreeDStockMaterialsFiltersCategoriesFilterItem;
